import _ from 'lodash';
import moment from 'moment';
import React, { useRef, useState } from "react";
import { generateClient } from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icons from '@fortawesome/free-regular-svg-icons';
import * as icons_solid from '@fortawesome/free-solid-svg-icons';
import { getSubjects } from '@/graphql/queries';
import { mergeSubject } from '@/graphql/mutations';
import Modal from '@/Modal';

const client = generateClient();

const infoIcon = (<FontAwesomeIcon className="text-primary" icon={icons_solid.faCircleInfo} size="lg" />);
const dangerIcon = (<FontAwesomeIcon className="text-danger" icon={icons_solid.faCircleExclamation} size="lg" />);
const arrowDownIcon = (<FontAwesomeIcon className="text-danger" icon={icons_solid.faArrowDown} size="xl" />);

export default ({ onClose, onSuccess, subject_id_from } = {}) => {
	const isConstructed = useRef(false);
	const [merging, setMerging] = useState(false);
	const [error, setError] = useState();
	const [success, setSuccess] = useState();
	const [subject_from, set_subject_from] = useState();
	const [subject_to, set_subject_to] = useState();

	const catchError = error => {
		if (error instanceof Error) {
			setError(error.toString());
		} else if (typeof error === 'string') {
			setError(error);
		} else {
			setError((error.errors || []).map(e => e.message?.toString()));
		}
	};

	if (!isConstructed.current) {
		isConstructed.current = true;
		(async () => {
			let res = await client.graphql({
				query: getSubjects,
				variables: { id: subject_id_from, subject_contacts_limit: 1 }
			});
			const from = res?.data?.getSubjects?.subjects?.[0];
			set_subject_from(from);
			if (from) {
				console.log('from', from);
				const filters = {
					phone_number: { eq: from.subject_phone_numbers?.[0].phone_number },
					is_possible_duplicate: { eq: false }
				};
				res = await client.graphql({
					query: getSubjects,
					variables: { filters, sorting: { field: 'created_at', order: 'asc' }, subject_contacts_limit: 1 }
				});
				const to = res?.data?.getSubjects?.subjects?.[0];
				if (!to) {
					setError('No other subject is found');
					setSuccess(false);
					onSuccess && onSuccess(false);
				} else {
					set_subject_to(to);
				}
			}
		})();
	}

	const merge = async event => {
		event.stopPropagation();
		setError();
		setMerging(true);
		try {
			let res = await client.graphql({
				query: mergeSubject,
				variables: { input: { subject_id_from: subject_from.id, subject_id_to: subject_to.id } }
			});
			console.log(res);
			if (res.data?.mergeSubject?.success) {
				// Read the "to" subject again to display the merge result
				res = await client.graphql({
					query: getSubjects,
					variables: { id: subject_to.id, subject_contacts_limit: 1 }
				});
				const to = res?.data?.getSubjects?.subjects?.[0];
				set_subject_to(to);
				setSuccess(true);
				onSuccess && onSuccess(true);
			}
		} catch (error) {
			console.error(error);
			catchError(error);
		} finally {
			setMerging(false);
		}
	};

	const loading = (!subject_from || !subject_to) && !error;

	return (
		<Modal
			footer={
				<>
					{success ? (
						<button className="btn btn-primary" data-bs-dismiss="modal">OK</button>
					) : (
						<>
							<button className="btn btn-danger" disabled={loading || merging || error} onClick={merge}>Merge</button>
							<button className="btn btn-link" data-bs-dismiss="modal" disabled={loading || merging}>Cancel</button>
						</>
					)}
				</>
			}
			isOpen={true}
			onClose={onClose}
			size="md"
			title={<span>Merge Confirmation</span>}
		>
			<div
				className="p-3"
				onClick={event => event.stopPropagation()}
			>
				{loading ? (
					<div className="text-center" style={{marginBottom:'2rem',marginTop:'2rem'}}>
						<button className="btn btn-primary" type="button" disabled>
							<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				) : (
					<div disabled="disabled">
						{merging && (
							<div className="text-center" style={{marginBottom:'2rem',marginTop:'2rem'}}>
								<button className="btn btn-primary" type="button" disabled>
									<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									Merging...
								</button>
							</div>
						)}
						{success && (
							<div className="text-dark text-center mx-3 my-3">{infoIcon} Successfully merged subject {subject_from.id} to {subject_to.id}.</div>
						)}
						{!merging && !success && (
							<div className="row">
								<div className="col-auto" style={{width: '80px'}}>
									<small><b>ID</b></small>
									<div>{subject_from?.id}</div>
								</div>
								<div className="col">
									<small><b>Name</b></small>
									<div>{subject_from?.full_name_first}</div>
								</div>
								<div className="col-auto" style={{width: '180px'}}>
									<small><b>Created At</b></small>
									<div>{moment(subject_from?.created_at).format('M/DD/YYYY h:mm A')}</div>
								</div>
								{subject_to && <div className="my-3 text-center">{arrowDownIcon}</div>}
							</div>
						)}
						{subject_to && (
							<div className="row">
								<div className="col-auto" style={{width: '80px'}}>
									<small><b>ID</b></small>
									<div>{subject_to?.id}</div>
								</div>
								<div className="col">
									<small><b>Name</b></small>
									<div>{subject_to?.full_name_first}</div>
								</div>
								<div className="col-auto" style={{width: '180px'}}>
									<small><b>Created At</b></small>
									<div>{moment(subject_to?.created_at).format('M/DD/YYYY h:mm A')}</div>
								</div>
							</div>
						)}
					</div>
				)}
			</div>
			{error &&
				<div className="text-danger">{dangerIcon} {error}</div>
			}
		</Modal>
	);
};
